const commentManage = resolve => require(['@/pages/content/commentManage/index.vue'], resolve);
const createContent = resolve => require(['@/pages/content/createContent/index.vue'], resolve);
const createImage = resolve => require(['@/pages/content/createContent/imageText/createImage.vue'], resolve);
const createEvaluate = resolve => require(['@/pages/content/createContent/evaluateTest/createEvaluate.vue'], resolve);
const imagetextDetail = resolve => require(['@/pages/content/createContent/imageText/detail.vue'], resolve);
const evaluateDetail = resolve => require(['@/pages/content/createContent/evaluateTest/detail.vue'], resolve);
const columnManage = resolve => require(['@/pages/content/columnManage/index.vue'], resolve);
const specialColumnManage = resolve => require(['@/pages/content/specialColumnManage/index.vue'], resolve); 
const tagManage = resolve => require(['@/pages/content/tagManage/index.vue'], resolve); 
const tag = resolve => require(['@/pages/content/tagManage/tag.vue'], resolve); 
const highlightManage = resolve => require(['@/pages/content/highlightManage/index.vue'], resolve); 
const preview = resolve => require(['@/pages/content/createContent/preview.vue'], resolve);

export default [
  /********************内容管理******************/
  {
    path: "/createContent",
    name: "自建内容",
    component: createContent,
  },
  {
    path: "/createContent/evaluateDetail",
    name: "查看评测",
    component: evaluateDetail,
  },
  {
    path: "/createContent/imagetextDetail",
    name: "查看图文",
    component: imagetextDetail,
  },
  {
    path: "/createContent/createImage",
    name: "自建内容-图文配置",
    component: createImage,
  },
  {
    path: "/createContent/createEvaluate",
    name: "自建内容-评测配置",
    component: createEvaluate,
  },
  {
    path: "/commentManage",
    name: "评论管理",
    component: commentManage
  },
  {
    path: "/columnManage",
    name: "栏目管理",
    component: columnManage
  },
  {
    path: "/specialColumnManage",
    name: "专栏管理",
    component: specialColumnManage
  },
  {
    path: "/tagManage",
    name: "标签管理",
    component: tagManage
  },
  {
    path: "/tag/:id",
    name: "标签",
    component: tag
  },{
    path: "/highlightManage",
    name: "突显管理",
    component: highlightManage
  },{
    path: "/contentPreview/:contentId",
    name: "内容预览",
    component: preview
  }
]